import { createContext, useContext } from "react";

const THEMES = ["dark", "light", "system"] as const;

export type Theme = (typeof THEMES)[number];

type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

const initialThemeState: ThemeProviderState = {
  theme: "system",
  setTheme: () => null,
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialThemeState);

export const isTheme = (value: string): value is Theme =>
  THEMES.includes(value as Theme);

export const useTheme = () => {
  const context = useContext(ThemeProviderContext);

  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
};
